<style>
    .pluss.accordion-button::after {
        background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='%23333' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' d='M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z' clip-rule='evenodd'/%3e%3c/svg%3e");
        transform: scale(.7) !important;
    }

    .pluss.accordion-button:not(.collapsed)::after {
        background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='%23333' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' d='M0 8a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1z' clip-rule='evenodd'/%3e%3c/svg%3e");
    }
</style>

<div class="container">
    <div class="row">
        <div class="col">
            <div class="card shadow p-3 mb-5 bg-body rounded">
                <div class="card-body">
                    <div class="tittleCard">
                        <div class="textoTitulo">
                            <div class="estiloTexto" *ngIf="this.planes">{{ this.planes.data[1].planName }}</div>
                        </div>
                        <div style="width: 140px;" class="align-items-end">
                            <div id="div_der">
                                <span class="estiloSubTexto">Pago único de </span>
                                <span class="textoNegrita" *ngIf="this.planes">${{ this.planes.data[1].price | number
                                    }}</span>
                            </div>
                        </div>
                    </div>
                    <button gtagEvent class="btn btn-primary w-100 py-2 boton" type="submit" trackOn="click"
                        action="standaloneTrue" (click)="ResumenPlan(1)">
                        Seleccionar
                    </button>
                    <hr>
                    <div class="mobile">
                        <div class="accordion" id="accordionDetalle">
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="flush-headingOne">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseOne" aria-expanded="false"
                                        aria-controls="flush-collapseOne" style="color: #2D6DF6;">
                                        <p class="verDetalle">Ver detalles</p>
                                    </button>
                                </h2>

                                <div id="flush-collapseOne" class="accordion-collapse collapse"
                                    aria-labelledby="flush-headingOne" data-bs-parent="#accordionDetalle">
                                    <div class="accordion-body">
                                        <br>
                                        <ul style="list-style-image:url(./assets/img/cheque.png);" *ngIf="this.planes">
                                            <li *ngFor="let cobertura of this.planes.data[1].coverages">
                                                <span class="cardsInternos estiloViñetas">{{
                                                    cobertura.name }}
                                                </span>
                                                <br>
                                                <div class="tipoLetra textoDescriptivo">
                                                    {{ cobertura.detail }}
                                                </div>
                                                <br>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="descktop">
                        <ul style="list-style-image:url(./assets/img/cheque.png);" *ngIf="this.planes">
                            <li *ngFor="let cobertura of this.planes.data[1].coverages">
                                <span class="cardsInternos estiloViñetas">{{
                                    cobertura.name }}
                                </span>
                                <br>
                                <div class="tipoLetra textoDescriptivo">
                                    {{ cobertura.detail }}
                                </div>
                                <br>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="col">
            <div class="card shadow p-3 mb-5 bg-body rounded">
                <div class="card-body">
                    <div class="tittleCard">
                        <div class="textoTitulo">
                            <div class="estiloTexto" *ngIf="this.planes">{{ this.planes.data[2].planName }}</div>
                        </div>
                        <div style="width: 140px" class="align-items-end">
                            <div id="div_der">
                                <span class="estiloSubTexto">Pago único de </span>
                                <span class="textoNegrita" *ngIf="this.planes">${{ this.planes.data[2].price | number
                                    }}</span>
                            </div>
                        </div>
                    </div>
                    <button gtagEvent class="btn btn-primary w-100 py-2 boton" type="submit" trackOn="click"
                        action="standaloneTrue" (click)="ResumenPlan(2)">
                        Seleccionar
                    </button>
                    <hr>

                    <div class="descktop">
                        <ul style="list-style-image:url(./assets/img/cheque.png);" *ngIf="this.planes">
                            <li *ngFor="let cobertura of this.planes.data[2].coverages">
                                <span class="cardsInternos estiloViñetas">{{
                                    cobertura.name }}
                                </span>
                                <br>
                                <div class="tipoLetra textoDescriptivo">
                                    {{ cobertura.detail }}
                                </div>
                                <br>
                            </li>
                        </ul>
                    </div>

                    <div class="mobile">
                        <div class="accordion" id="accordionDetalle2">
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="flush-headingOne">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseTwo" aria-expanded="false"
                                        aria-controls="flush-collapseTwo">
                                        <p class="verDetalle">Ver detalles</p>
                                    </button>
                                </h2>

                                <div id="flush-collapseTwo" class="accordion-collapse collapse"
                                    aria-labelledby="flush-headingTwo" data-bs-parent="#accordionDetalle2">
                                    <div class="accordion-body">
                                        <ul style="list-style-image:url(./assets/img/cheque.png);" *ngIf="this.planes">
                                            <li *ngFor="let cobertura of this.planes.data[2].coverages">
                                                <span class="cardsInternos estiloViñetas">{{
                                                    cobertura.name }}
                                                </span>
                                                <br>
                                                <div class="tipoLetra textoDescriptivo">
                                                    {{ cobertura.detail }}
                                                </div>
                                                <br>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="col">
            <div class="card shadow p-3 mb-5 bg-body rounded">
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <div class="armaTuPlan" *ngIf="this.planes">{{ this.planes.data[0].planName }}</div>
                        </div>
                        <div class="col" style="text-align: right;">
                            <button class="btn btn-primary rounded-pill px-3 botonNew">
                                Nuevo
                            </button>
                        </div>
                    </div>

                    <br>
                    <div class="row">
                        <span class="textoDescriptivoNegrita">La tarifa es flexible.
                            <span class="textoDescriptivo"> Ajusta las coberturas a tu medida.</span>
                        </span>
                    </div>

                    <br>
                    <button gtagEvent class="btn btn-primary w-100 py-2 boton" type="submit" trackOn="click"
                        action="standaloneTrue" (click)="ArmarPlan(0)">
                        Personalizar
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>